import type { PlanColor } from "./_types";

export const HeadingTitleStyle: Record<PlanColor, string> = {
  purple: "text-purple-300",
  sky: "text-sky-300",
  green: "text-emerald-300",
}

export const PurchaseButtonStyle: Record<PlanColor, string> = {
  purple: "bg-purple-600 hover:bg-purple-700",
  sky: "bg-sky-600 hover:bg-sky-700",
  green: "bg-emerald-600 hover:bg-emerald-700",

}

export const BannerStyle: Record<PlanColor, string> = {
  purple: "from-purple-400 to-blue-400",
  sky: "from-sky-400 to-indigo-400",
  green: "from-green-400 to-emerald-400",
}

export const ItemStyle: Record<PlanColor, string> = {
  purple: "hover:border-purple-400/60 border-purple-400/20",
  sky: "hover:border-sky-400/60 border-sky-400/20",
  green: "hover:border-emerald-400/60 border-emerald-400/20"
}
